import React from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import interior from '../assets/images/interior.jpg';
import engine from '../assets/images/engine.jpg';
import tire from '../assets/images/tire.jpg';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-vial',
      title: 'Laboratory Testing',
      description: 'Comprehensive blood tests, urine analysis, and other diagnostic laboratory investigations.',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-baby',
      title: 'Ultrasound Services',
      description: 'Advanced ultrasound imaging for pregnancy monitoring and general diagnostic purposes.',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-x-ray',
      title: 'X-Ray Services',
      description: 'Digital X-ray imaging for bone fractures, chest examinations, and diagnostic imaging.',
      image: 'https://images.unsplash.com/photo-1559757175-0eb30cd8c063?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-microscope',
      title: 'Pathology Services',
      description: 'Microscopic examination and analysis of tissue samples and cellular specimens.',
      image: 'https://images.unsplash.com/photo-1582719471384-894fbb16e074?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-heartbeat',
      title: 'Cardiac Testing',
      description: 'ECG, stress tests, and other cardiac diagnostic procedures for heart health assessment.',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    },
    {
      icon: 'fas fa-user-md',
      title: 'General Diagnostics',
      description: 'Complete health check-ups and comprehensive diagnostic services for overall wellness.',
      image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80'
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Our Medical Services</h2>
          <p>Comprehensive healthcare diagnostic services designed to support your health and wellness</p>
        </div>
        
        <div className="services-grid grid grid-3">
          {services.map((service, index) => (
            <motion.div 
              key={index} 
              className="service-card card"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              whileHover={{ y: -10, scale: 1.02 }}
            >
              <div className="service-image">
                <img src={service.image} alt={service.title} />
                <div className="service-overlay">
                  <motion.div 
                    className="service-icon"
                    whileHover={{ scale: 1.2, rotate: 360 }}
                    transition={{ duration: 0.3 }}
                  >
                    <i className={service.icon}></i>
                  </motion.div>
                </div>
              </div>
              <div className="service-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;